const FormSelectCSS = {
    control: (provided) => ({
        ...provided,
        width: '33vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: '10px',
        marginTop: '0',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
}

const CSSForSelectSmallWidth = {
    control: (provided) => ({
        ...provided,
        width: '30vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '20vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};

const CSSForSelect10vWWidth = {
    control: (provided) => ({
        ...provided,
        width: '10vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '10vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};

const CSSForFilterDropdown = {
    control: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        // padding: "0.6rem 0.5rem",
        textTransform: "capitalize",
        // width: "11vw"
    }),
    placeholder: (provided) => ({ ...provided, color: "#707070" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    singleValue: (provided) => ({ ...provided, color: "#707070" }),
    dropdownIndicator: (provided) => ({
        ...provided,
        filter: "invert(50%)",
        cursor: "pointer",
        left: "9.5rem",
        // width: "20px",
        // height: "20px",
        fontSize: "12px",
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "12px",
        color: state.isSelected ? "#ffffff" : "#707070",
        backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
        cursor: "pointer",
        "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
    }),
}

const CSSForSelect = {
    control: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        textTransform: "capitalize",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    menu: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        padding: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    option: (provided, state) => ({
        ...provided,
        textTransform: "capitalize",
        backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
        color: '#4a4a4a',
    }),
};

const QuillEditorModules = {
    toolbar: [
        [{ font: [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "image", "video"],
        ["code-block"],
        ["clean"],
    ],
};

const QuillEditorFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "align",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "code-block",
];

const getPageDimensionsPx = (pageSize) => {
    const dpi = 96; // standard screen resolution
    const mmToInch = 0.0393701;

    const sizes = {
        A4: { width: 210, height: 297 },
        A3: { width: 297, height: 420 },
        Letter: { width: 216, height: 279 },
    };

    const size = sizes[pageSize] || sizes.A4;

    return {
        width: size.width * mmToInch * dpi,
        height: size.height * mmToInch * dpi,
    };
};


export {
    FormSelectCSS,

    CSSForSelect,
    CSSForSelectSmallWidth,
    CSSForSelect10vWWidth,
    CSSForFilterDropdown,

    QuillEditorModules,
    QuillEditorFormats,

    getPageDimensionsPx,
}